import { useEffect, useRef } from "react";
import { track } from "@/lib/track";

// Fires a single `section_view` event the first time the section reaches the middle of the
// viewport (works for sections taller than the screen), so drop-off between sections shows
// up as a funnel in GA4.
export function useSectionView<T extends HTMLElement>(section: string, page = "home") {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          track("section_view", { section, page });
          observer.disconnect();
        }
      },
      { rootMargin: "-45% 0px -45% 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [section, page]);

  return ref;
}
